import styled from "styled-components/macro";

import {useParams} from "react-router-dom";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import HeaderData from "../../components/header_data";
import {useModal, useRelativeTime} from "../../store";
import {useQuery} from "../../utils/router";
import NavLink from "../../components/nav_link";
import Pagination from "../../components/pagination";
import {isPseudoCommunity} from "../../store/communites";
import {useFeedback} from "../../store/feedback";
import {useBans, useUnban} from "../../api/moderation";
import {useState} from "react";
import CommunityInfo from "../../components/community_info";
import {themecolors} from "../../utils/themecolors";
import {Button, useToast} from "@chakra-ui/react";
import UnbanUser from "../../components/modals/moderation/unban_user";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";
import useWindowDimensions from "../../utils/dimensions";

const SortOptions = styled.div``;
const Expand = styled.span``;
const Info = styled.span``;

const User = styled.span``;
const Headline = styled.div``;
const Details = styled.div``;
const Ago = styled.div``;
const Unban = styled.div``;

const Options = styled.div``;
const Buttons = styled.div``;

const BanEntry = styled(({className, ban, setTime}) => {
    const ago = useRelativeTime(ban.created, true);
    return (
        <div className={className}>
            <Headline>
                <User><NavLink href={`/u/${ban.author}`} react_route>{ban.author} </NavLink></User>
                <Info>
                    banned by <NavLink href={`/u/${ban.moderator}`} react_route>{ban.moderator}</NavLink>
                </Info>
            </Headline>
            <Options>
                <Ago>{ago} ago</Ago>
            </Options>
        </div>
    )
})`
  padding: 12px 20px;
  border-bottom: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_3 : 'rgb(219, 219, 219)'};
  display: flex;

  ${User} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : theme.placeholder_link_2};
  }

  ${Ago}, ${Info} {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_medium_impact_text : themecolors.light_medium_impact_text};
  }

  ${Unban} {
    cursor: pointer;
    padding-right: 8px;
  }
  ${Options} {
    padding-left: 8px;
    display: flex;
  }
`;

const Bans = styled(({logType, className}) => {

    const {error, feedbackCh} = useFeedback();
    const baseCommunity = useBaseCommunity();
    const {community: paramsCommunity} = useParams();
    const community = paramsCommunity || baseCommunity;
    const style = useCommunityStyle(community);
    const page = parseInt(useQuery().page || '1');

    const [time, setTime] = useState(Date.now());
    const bans = useBans(feedbackCh, community, page, time);

    const unban = useUnban(feedbackCh);
    const toast = useToast();
    const modal = useModal();
    const handleUnban = async () => {
        modal.open(UnbanUser, {community});
    };

    const {width} = useWindowDimensions();

    return (
        <>
            <HeaderData title={`Community Bans`} community={community} community_style={style}/>
            <Header>
                {(baseCommunity !== "TheDonald" || width <= 780) && <TopBar legacyConversion={baseCommunity === "TheDonald"} />}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                        {baseCommunity !== "TheDonald" &&
                            <CommunityInfo desktop community={community}/>
                        }
                    </>
                }
                {baseCommunity === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container className={className} forceWidth={"slim"}>
                <Wrapper>
                    <Main>
                            {bans && bans.map((ban, i) => (
                                    <BanEntry key={i} ban={ban} setTime={setTime}/>
                            ))}
                        <Buttons>
                            <Button variant={"grey"} onClick={handleUnban}>Unban</Button>
                        </Buttons>
                    </Main>
                    <Pagination path={`?page=`} has_more page={page} />
                </Wrapper>
                <Sidebar sidebar={style?.sidebar} community={community} />
            </Container>
            <Footer />
        </>
    );
})`
  ${Main} {
    font-size: 14px;
  }
  ${Expand} {
    cursor: pointer;
  }
  ${SortOptions} {
    margin-left: auto;
    display: flex;
  }
  ${Buttons} {
    display: flex;
    justify-content: flex-end;
    padding: 12px;
  }
`;

export default Bans;
